import React from 'react';
import { Component } from '@poa/core';
import { getProfileIcon } from '../../icons/profile';


class AccountPassword extends React.Component {
    store; // injected by Poa

    render() {
        const { originalModel } = this.store.accounts;

        return (
            <div className='general_info__content'>
                {
                    originalModel !== null ?
                        <div className="account-history">
                            <div className="account-history__item">
                                <div className="account-history__body">
                                    <table className="account-history__table">
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>ФИО</th>
                                                <th>Дата</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {originalModel.password_history.map(history => (
                                                <tr key={history.user_id}>
                                                    <td>{history.user_id}</td>
                                                    <td>{history.last_name} {history.first_name}</td>
                                                    <td>{history.created_at}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        :
                        <div className='main-row'>
                            <div className='no-profile-found-text'>
                                {getProfileIcon('noUser')}
                                Профиль не найден
                            </div>
                        </div>
                }
            </div>
        );
    }
}

export default Component({ namespaces: ['account-password'] })(AccountPassword);